export class CompareData {
    public title: string;
    public content: string;
}
